const validate = require('validate.js');

const PASSWORD_MAX_LENGTH = 32;
const PASSWORD_MIN_LENGTH = 7;

const pwdLengthOptions = {
    min: PASSWORD_MIN_LENGTH,
    max: PASSWORD_MAX_LENGTH
};

const pwdLengthValidationOptions = {
    minimum: PASSWORD_MIN_LENGTH,
    maximum: PASSWORD_MAX_LENGTH,
    message: 'ums.validation.password.length'
};

const validatePasswordConstraint = {
    p: {
        presence: true,
        regex: {
            // ?= is the look ahead char in regex
            // so this is a search ahead to find either
            // a letter character AND a number or
            // a single character in the unicode range
            pattern: '(?=.*?[0-9])(?=.*?[a-zA-Z])|(?=.*?[\u{128}-\u{FFFF}])',
            message: 'ums.validation.password.regex'
        },
        length: pwdLengthValidationOptions
    }
};

// Following is a fix to get regex to work, apparently it's a known issue
validate.validators.regex = function(value, options) {
    let regExp = new RegExp(options.pattern);

    if (!regExp.test(value)) {
        return options.message;
    }
    return null;
};

module.exports = {
    validatePasswordConstraint,
    pwdLengthOptions,
    validate
};
